import { Form } from "antd";
import { SecondaryAgentType } from "../../../enums";
import { CreateUpdateSecondaryAgent } from "../../../types";
import { LegalSecondaryAgentDataFormPart } from "./LegalSecondaryAgentDataFormPart";
import { NaturalSecondaryAgentDataFormPart } from "./NaturalSecondaryAgentDataFormPart";
import { SelfEmployedSecondaryAgentDataFormPart } from "./SelfEmployedSecondaryAgentDataFormPart";

type Props = {
  isCreatingNewAgent?: boolean;
};

export const BasicSecondaryAgentData = ({ isCreatingNewAgent }: Props) => {
  const form = Form.useFormInstance<CreateUpdateSecondaryAgent>();
  const type = Form.useWatch("type", form);

  if (type === SecondaryAgentType.NATURAL) {
    return <NaturalSecondaryAgentDataFormPart allowSearch={isCreatingNewAgent} />;
  } else if (type === SecondaryAgentType.SELF_EMPLOYED) {
    return <SelfEmployedSecondaryAgentDataFormPart allowSearch={isCreatingNewAgent} />;
  }

  return <LegalSecondaryAgentDataFormPart allowSearch={isCreatingNewAgent} />;
};
